import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react'; // <-- hier fehlte der Import
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import Login from './pages/Login';
import Products from './pages/Products';
import Register from './pages/Register';
import Stock from './pages/Stock';
import Partners from './pages/Partners';
import Dashboard from './pages/Dashboard';
import Cash from './pages/Cash';
import Suppliers from './pages/Suppliers';
import Finance from './pages/Finance';
import Expenses from './pages/Expenses';
import Payroll from './pages/Payroll';
import Users from './pages/Users';
import IncomingDocuments from './pages/IncomingDocuments';
import Navbar from './components/Navbar';
import Landing from './pages/Landing';



function PrivateRoute({ children }) {
  const { user, ready } = useContext(AuthContext);
  if (!ready) return null;
  return user ? children : <Navigate to="/login" />;
}

function RoleRoute({ roles, children }) {
  const { user, ready } = useContext(AuthContext);
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={user.role === 'EMPLOYEE' ? '/register' : '/products'} replace />;
  return children;
}

function HomeRedirect() {
  const { user, ready } = useContext(AuthContext);
  if (!ready) return null;
  if (!user) return <Landing />;
  return <Navigate to="/register" replace />;
}

export default function App() {
  return (
    <Router>
      <SnackbarProvider>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/products" element={<RoleRoute roles={['ADMIN']}><Products /></RoleRoute>} />
            <Route path="/register" element={<PrivateRoute><Register /></PrivateRoute>} />
            <Route path="/tires" element={<Navigate to="/products" replace />} />
            <Route path="/stock" element={<RoleRoute roles={['ADMIN']}><Stock /></RoleRoute>} />
            <Route path="/partners" element={<RoleRoute roles={['ADMIN']}><Partners /></RoleRoute>} />
            <Route path="/suppliers" element={<RoleRoute roles={['ADMIN']}><Suppliers /></RoleRoute>} />
            <Route path="/cash" element={<RoleRoute roles={['ADMIN']}><Cash /></RoleRoute>} />
            <Route path="/finance" element={<RoleRoute roles={['ADMIN']}><Finance /></RoleRoute>} />
            <Route path="/expenses" element={<RoleRoute roles={['ADMIN']}><Expenses /></RoleRoute>} />
            <Route path="/payroll" element={<PrivateRoute><Payroll /></PrivateRoute>} />
            <Route path="/users" element={<RoleRoute roles={['ADMIN']}><Users /></RoleRoute>} />
            <Route path="/incoming-documents" element={<RoleRoute roles={['ADMIN']}><IncomingDocuments /></RoleRoute>} />
            <Route path="/dashboard" element={<RoleRoute roles={['ADMIN']}><Dashboard /></RoleRoute>} />
            <Route path="/" element={<HomeRedirect />} />
          </Routes>
        </AuthProvider>
      </SnackbarProvider>
    </Router>
  );
}
